import { render } from "./EditDetailAgendaView.vue?vue&type=template&id=162c6c9c"
import script from "./EditDetailAgendaView.vue?vue&type=script&lang=js"
export * from "./EditDetailAgendaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__